import {Component} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SearchBoxComponentService, SearchBoxConfig, SearchResults} from '@spartacus/storefront';

import {Observable} from 'rxjs';

interface SuggestedListModel {
  recommended?: string[];
  suggested?: string[];
}

export const DEFAULT_SEARCHBOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  displayProducts: true,
  displaySuggestions: true,
  maxProducts: 4,
  maxSuggestions: 4,
  displayProductImages: false,
};

@UntilDestroy()
@Component({
  selector: 'dcp-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent {
  constructor(protected searchBoxComponentService: SearchBoxComponentService) {}

  results$: Observable<SearchResults>;
  config: SearchBoxConfig = DEFAULT_SEARCHBOX_CONFIG;
  suggestionList: SuggestedListModel = {
    recommended: undefined,
    suggested: undefined
  };
  suggestionListString: string = '';
  type = 'Search';

  handleSearch(query: string): void {
    this.search(query);
    this.searchBoxComponentService.getResults(DEFAULT_SEARCHBOX_CONFIG)
      .pipe(untilDestroyed(this))
      .subscribe(results => {
        this.suggestionList.suggested = results?.suggestions;
        this.suggestionList.recommended = results?.products?.map(product => product.name);
        this.suggestionListString = JSON.stringify(this.suggestionList);
    });
  }

  submitSearch(query: string): void {
    this.searchBoxComponentService.launchSearchPage(query);
  }

  search(query: string): void {
    if (query.length < this.config.minCharactersBeforeRequest) {
      this.searchBoxComponentService.search('', this.config);
    } else {
      this.searchBoxComponentService.search(query, this.config);
    };
  }

  clearSearch() {
    this.suggestionListString = '';
    this.searchBoxComponentService.launchSearchPage('');
  }
}
